// extracted by mini-css-extract-plugin
export default {"container":"DisplayException_container__MxlLO","errorMessage":"DisplayException_errorMessage__PRBad"};